import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";

import { replaceClass } from "../../../../../../../Tools/Classtools";
import { useUserInfor } from "../../../../../../../Context/User";
import { AtualizarConfigGeralController } from "../../../../../../../Controllers/Geral/GestaoDeCadastros/ConfigGeral/ConfigGeralController";
import { IConfigGeral_Geral } from "../../../../../../../Interfaces/Geral/GestaoDeCadastro/ConfigGeral/ConfigGeralInterface";
import { ACESSOS } from "../../../../../../../Routes/Acessos";
import SelectCategoriaAtendimento from "../../../../../../CardsPages/Forms/SelectCategoriaAtendimento";

interface IHorarioForm {
    inicio: string;
    fim: string;
}

interface ICategoriaAtendimentoForm {
    ID_CATEGORIA_ATENDIMENTO_PADRAO_BOLETO: number;
    ID_CATEGORIA_ATENDIMENTO_PADRAO_EXTRATO: number;
    ID_CATEGORIA_ATENDIMENTO_URA: number;
}

export default function GeralConfig() {
    const { Config, updateConfig } = useUserInfor();
    const config = Config.ConfigVersaoWebServiceDTO;
    const configURA = Config.ConfigUraIntegracaoTelefoniaDTO;
    const { register, handleSubmit, formState, watch } =
        useForm<IHorarioForm>();
    const formCategoriaAtendimentoCaso = useForm<ICategoriaAtendimentoForm>();

    const formWatcher = watch();

    const [categoriaAtendimentoForm, setCategoriaAtendimentoForm] = useState({
        ID_CATEGORIA_ATENDIMENTO_PADRAO_BOLETO:
            config.ID_CATEGORIA_ATENDIMENTO_PADRAO_BOLETO,
        ID_CATEGORIA_ATENDIMENTO_PADRAO_EXTRATO:
            config.ID_CATEGORIA_ATENDIMENTO_PADRAO_EXTRATO,
        ID_CATEGORIA_ATENDIMENTO_URA: configURA.ID_CATEGORIA_ATENDIMENTO_URA,
    });

    function update() {
        AtualizarConfigGeralController({
            ...Config,
            ConfigVersaoWebServiceDTO: {
                ...config,
            },
            ConfigUraIntegracaoTelefoniaDTO: {
                ...configURA,
            },
        }).then(() => {
            updateConfig();
        });
    }
    function handleHorarioFormSubmit(formData: IHorarioForm) {
        config.HR_INICIO = formData.inicio;
        config.HR_FIM = formData.fim;
        update();
    }
    function handleConfigCategoriaFormSubmit(
        formData: ICategoriaAtendimentoForm
    ) {
        config.ID_CATEGORIA_ATENDIMENTO_PADRAO_BOLETO =
            formData.ID_CATEGORIA_ATENDIMENTO_PADRAO_BOLETO;
        config.ID_CATEGORIA_ATENDIMENTO_PADRAO_EXTRATO =
            formData.ID_CATEGORIA_ATENDIMENTO_PADRAO_EXTRATO;
        configURA.ID_CATEGORIA_ATENDIMENTO_URA =
            formData.ID_CATEGORIA_ATENDIMENTO_URA;
        update();
    }
    const showSubmitButton = (formWatcher: any, config: IConfigGeral_Geral) => {
        const { inicio, fim } = formWatcher;

        if (inicio !== config.HR_INICIO || fim !== config.HR_FIM)
            replaceClass("geral_form_submit_button", "d-none", "d-flex");
        else replaceClass("geral_form_submit_button", "d-flex", "d-none");
    };
    const handleInputChange = () => {
        showSubmitButton(formWatcher, config);
    };

    //faz a atualização do botão sempre que há uma atualização no config
    useEffect(() => {
        if (formWatcher.inicio && formWatcher.fim)
            showSubmitButton(formWatcher, Config.ConfigVersaoWebServiceDTO);
    }, [Config, formWatcher]);

    return (
        <div className="row">
            <div className="col-12 mb-4">
                <h4>Horário de trabalho</h4>
                <div className="d-flex flex-column">
                    <form
                        onSubmit={handleSubmit(handleHorarioFormSubmit)}
                        className="row"
                    >
                        <div className="col-6 mb-2">
                            <label>Início</label>
                            <input
                                className={`form-control placeholder-dark-75 ${
                                    formState.errors.inicio && "is-invalid"
                                }`}
                                type="time"
                                defaultValue={config.HR_INICIO}
                                name="inicio"
                                ref={register({
                                    required:
                                        "Insira o inicio do horário de trabalho",
                                })}
                                onChange={handleInputChange}
                            />
                            <div className="invalid-feedback">
                                {formState.errors.inicio
                                    ? formState.errors.inicio.message
                                    : ""}
                            </div>
                        </div>
                        <div className="col-6 mb-2">
                            <label>Fim</label>
                            <input
                                className={`form-control placeholder-dark-75 ${
                                    formState.errors.fim && "is-invalid"
                                }`}
                                type="time"
                                defaultValue={config.HR_FIM}
                                name="fim"
                                ref={register({
                                    required:
                                        "Insira o fim do horário de trabalho",
                                })}
                                onChange={handleInputChange}
                            />
                            <div className="invalid-feedback">
                                {formState.errors.fim
                                    ? formState.errors.fim.message
                                    : ""}
                            </div>
                        </div>

                        <div className="col-12">
                            <button
                                className="btn btn-outline-success font-weight-bold d-none col-12 justify-content-center"
                                id="geral_form_submit_button"
                            >
                                <FontAwesomeIcon
                                    icon={faEdit}
                                    size="lg"
                                    className="mr-1"
                                />{" "}
                                Atualizar dados
                            </button>
                        </div>
                    </form>
                </div>
            </div>
            <div className="col-12 mb-4">
                <h4>Agenda</h4>
                <div className="d-flex flex-column">
                    <label className="col-12 col-form-label px-0">
                        Permitir agendar em feriados e fins de semana
                    </label>
                    <div className="col-12">
                        <span className="switch switch-outline switch-icon switch-success">
                            <label>
                                <input
                                    type="checkbox"
                                    checked={
                                        config.FL_AGENDAR_EM_FERIADOS_E_FIM_DE_SEMANA
                                    }
                                    onChange={() => {
                                        config.FL_AGENDAR_EM_FERIADOS_E_FIM_DE_SEMANA =
                                            !config.FL_AGENDAR_EM_FERIADOS_E_FIM_DE_SEMANA;
                                        update();
                                    }}
                                    name="select"
                                />
                                <span></span>
                            </label>
                        </span>
                    </div>
                </div>
            </div>

            <div className="col-12 mb-4">
                <h4>Formulário</h4>
                <div className="d-flex flex-column">
                    <label className="col-12 col-form-label px-0">
                        Pesquisa de Satisfação para Atendimento ao Cliente
                    </label>
                    <div className="col-12">
                        <span className="switch switch-outline switch-icon switch-success">
                            <label>
                                <input
                                    type="checkbox"
                                    checked={Config.ConfigAtendimentoDTO.FL_NPS}
                                    onChange={() => {
                                        Config.ConfigAtendimentoDTO.FL_NPS =
                                            !Config.ConfigAtendimentoDTO.FL_NPS;
                                        update();
                                    }}
                                    name="select"
                                />
                                <span></span>
                            </label>
                        </span>
                    </div>
                </div>
            </div>
            <div>
                <div className="col-12 mb-4">
                    <h4>Assistência Técnica</h4>
                    <div className="d-flex flex-column">
                        <label className="col-12 col-form-label px-0">
                            Permitir enviar email
                        </label>
                        <div className="col-12">
                            <span className="switch switch-outline switch-icon switch-success">
                                <label>
                                    <input
                                        type="checkbox"
                                        checked={
                                            Config.FL_ENVIAR_EMAIL_AGENDAMENTO_ASS
                                        }
                                        onChange={() => {
                                            Config.FL_ENVIAR_EMAIL_AGENDAMENTO_ASS =
                                                !Config.FL_ENVIAR_EMAIL_AGENDAMENTO_ASS;
                                            update();
                                        }}
                                        name="select"
                                    />
                                    <span></span>
                                </label>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-12 mb-4">
                <h4>Transferir atendimentos</h4>
                <div className="d-flex flex-column">
                    <label className="col-12 col-form-label px-0">
                        Listar apenas os usuários que pertencem ao mesmo grupo
                        na Transferência de Atendimentos.
                    </label>
                    <div className="col-12">
                        <span className="switch switch-outline switch-icon switch-success">
                            <label>
                                <input
                                    type="checkbox"
                                    checked={
                                        !Config.ConfigCRMDTO
                                            .FL_LISTAR_TODOS_USUARIOS_TRANSFERENCIA
                                    }
                                    onChange={() => {
                                        Config.ConfigCRMDTO.FL_LISTAR_TODOS_USUARIOS_TRANSFERENCIA =
                                            !Config.ConfigCRMDTO
                                                .FL_LISTAR_TODOS_USUARIOS_TRANSFERENCIA;
                                        update();
                                    }}
                                    name="select"
                                />
                                <span></span>
                            </label>
                        </span>
                    </div>
                </div>
            </div>
            <div className="col-12 mb-4">
                <h4>SLA Dias úteis ou corridos</h4>
                <div className="d-flex flex-column">
                    <label className="col-12 col-form-label px-0">
                        {Config.ConfigAssistenciaTecnicaDTO
                            .FL_SLA_DIAS_CORRIDOS === true
                            ? "Dias corridos"
                            : "Dias úteis"}
                    </label>
                    <div className="col-12">
                        <span className="switch switch-outline switch-icon switch-success">
                            <label>
                                <input
                                    type="checkbox"
                                    checked={
                                        Config.ConfigAssistenciaTecnicaDTO
                                            .FL_SLA_DIAS_CORRIDOS
                                    }
                                    onChange={() => {
                                        Config.ConfigAssistenciaTecnicaDTO.FL_SLA_DIAS_CORRIDOS =
                                            !Config.ConfigAssistenciaTecnicaDTO
                                                .FL_SLA_DIAS_CORRIDOS;
                                        update();
                                    }}
                                    name="select"
                                />
                                <span></span>
                            </label>
                        </span>
                    </div>
                </div>
            </div>
            <div className="col-12 mb-4">
                <h4>Associar Histórico no E-mail</h4>
                <div className="d-flex flex-column">
                    <label className="col-12 col-form-label px-0">
                        {Config.FL_ENVIAR_HISTORICO_EMAIL === true
                            ? "Enviar e-mail se estiver associado a um histórico"
                            : "Enviar e-mail sem necessidade de associar a um histórico"}
                    </label>
                    <div className="col-12">
                        <span className="switch switch-outline switch-icon switch-success">
                            <label>
                                <input
                                    type="checkbox"
                                    checked={Config.FL_ENVIAR_HISTORICO_EMAIL}
                                    onChange={() => {
                                        Config.FL_ENVIAR_HISTORICO_EMAIL =
                                            !Config.FL_ENVIAR_HISTORICO_EMAIL;
                                        update();
                                    }}
                                    name="select"
                                />
                                <span></span>
                            </label>
                        </span>
                    </div>
                </div>
            </div>
            <div className="col-12 mb-4">
                <h4>Gestão de Grupos e Usuários</h4>
                <div className="d-flex flex-column">
                    <label className="col-12 col-form-label px-0">
                        Listar Somente usuários e grupos pertencentes ao usuário
                        logado
                    </label>
                    <div className="col-12">
                        <span className="switch switch-outline switch-icon switch-success">
                            <label>
                                <input
                                    type="checkbox"
                                    checked={Config.FL_RESTRICAO_GRUPO_USUARIO}
                                    onChange={() => {
                                        Config.FL_RESTRICAO_GRUPO_USUARIO =
                                            !Config.FL_RESTRICAO_GRUPO_USUARIO;
                                        update();
                                    }}
                                    name="select"
                                />
                                <span></span>
                            </label>
                        </span>
                    </div>
                </div>
            </div>
            <div className="col-12 mb-4">
                <h4>Manter último módulo acessado</h4>
                <div className="d-flex flex-column">
                    <label className="col-12 col-form-label px-0">
                        Deseja retornar automaticamente ao último módulo
                        acessado?
                    </label>
                    <div className="col-12">
                        <span className="switch switch-outline switch-icon switch-success">
                            <label>
                                <input
                                    type="checkbox"
                                    checked={Config.FL_ULTIMO_MODULO}
                                    onChange={() => {
                                        Config.FL_ULTIMO_MODULO =
                                            !Config.FL_ULTIMO_MODULO;
                                        update();
                                    }}
                                    name="select"
                                />
                                <span></span>
                            </label>
                        </span>
                    </div>
                </div>
            </div>
            <div className="col-12 mb-4">
                <h4>Gestão de Clientes e Unidades</h4>
                <div className="d-flex flex-column">
                    <label className="col-12 col-form-label px-0">
                        Mostrar apenas clientes vinculados a unidade de obras ao
                        qual os grupos do usuário
                    </label>
                    <div className="col-12">
                        <span className="switch switch-outline switch-icon switch-success">
                            <label>
                                <input
                                    type="checkbox"
                                    checked={Config.FL_RESTRICAO_GRUPO_OBRA}
                                    onChange={() => {
                                        Config.FL_RESTRICAO_GRUPO_OBRA =
                                            !Config.FL_RESTRICAO_GRUPO_OBRA;
                                        update();
                                    }}
                                    name="select"
                                />
                                <span></span>
                            </label>
                        </span>
                    </div>
                </div>
            </div>
            <div className="col-12">
                <h4>Abertura de Caso</h4>
                <form
                    className="row"
                    onSubmit={formCategoriaAtendimentoCaso.handleSubmit(
                        handleConfigCategoriaFormSubmit
                    )}
                >
                    <div className="d-flex flex-column col-12 col-md-6">
                        <label>
                            Categoria padrão para abrir caso ao gerar boleto
                        </label>
                        <SelectCategoriaAtendimento
                            defaultValue={
                                config.ID_CATEGORIA_ATENDIMENTO_PADRAO_BOLETO
                            }
                            ID_MODULO={ACESSOS.ATENDIMENTO.ID_MODULO}
                            name="ID_CATEGORIA_ATENDIMENTO_PADRAO_BOLETO"
                            setIdCategoria={(id) => {
                                setCategoriaAtendimentoForm({
                                    ...categoriaAtendimentoForm,
                                    ID_CATEGORIA_ATENDIMENTO_PADRAO_BOLETO:
                                        id as number,
                                });
                            }}
                            control={formCategoriaAtendimentoCaso.control}
                        />
                    </div>
                    <div className="d-flex flex-column col-12 col-md-6">
                        <label>
                            Categoria padrão para abrir caso ao gerar extrato
                        </label>
                        <SelectCategoriaAtendimento
                            defaultValue={
                                config.ID_CATEGORIA_ATENDIMENTO_PADRAO_EXTRATO
                            }
                            ID_MODULO={ACESSOS.ATENDIMENTO.ID_MODULO}
                            name="ID_CATEGORIA_ATENDIMENTO_PADRAO_EXTRATO"
                            setIdCategoria={(id) => {
                                setCategoriaAtendimentoForm({
                                    ...categoriaAtendimentoForm,
                                    ID_CATEGORIA_ATENDIMENTO_PADRAO_EXTRATO:
                                        id as number,
                                });
                            }}
                            control={formCategoriaAtendimentoCaso.control}
                        />
                    </div>
                    <div className="col-12">
                        {(categoriaAtendimentoForm.ID_CATEGORIA_ATENDIMENTO_PADRAO_BOLETO !==
                            config.ID_CATEGORIA_ATENDIMENTO_PADRAO_BOLETO ||
                            categoriaAtendimentoForm.ID_CATEGORIA_ATENDIMENTO_PADRAO_EXTRATO !==
                                config.ID_CATEGORIA_ATENDIMENTO_PADRAO_EXTRATO ||
                            categoriaAtendimentoForm.ID_CATEGORIA_ATENDIMENTO_URA !==
                                configURA.ID_CATEGORIA_ATENDIMENTO_URA) && (
                            <button
                                className="btn btn-outline-success font-weight-bold col-12 justify-content-center mt-2"
                                type="submit"
                            >
                                <FontAwesomeIcon
                                    icon={faEdit}
                                    size="lg"
                                    className="mr-1"
                                />{" "}
                                Atualizar dados
                            </button>
                        )}
                    </div>
                </form>
            </div>
        </div>
    );
}
